import { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { onlyNumbers } from '../../../utils/normalize';
import UserRepository from '../../../repositories/UserRepository';
import { validadePhone } from '../../../utils/validation';

export const useForgotPassword = ({ handleOption, history }) => {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [phoneFlow, setPhoneFlow] = useState(false);
  const [inputCode, setInputCode] = useState('');
  const [challenge, setChallenge] = useState(null);

  const handleSubmit = async () => {
    if (validadePhone(onlyNumbers(value))) {
      return await sendPhone();
    }
    return await sendEmail();
  };

  const sendPhone = async () => {
    setLoading(true);
    try {
      const data = await UserRepository.restorePasswordByPhone({
        phone: onlyNumbers(value),
      });
      if (!data || !data.challenge) {
        return toastr.error('Erro ao tentar enviar o Telefone');
      }
      setChallenge(data.challenge);
      setPhoneFlow(true);
    } catch (err) {
      if (err?.response?.data?.message) {
        return toastr.error('Atenção', err.response.data.message);
      }
      return toastr.error('Erro ao tentar enviar o Telefone');
    } finally {
      setLoading(false);
    }
  };

  const sendEmail = async () => {
    setLoading(true);
    try {
      await UserRepository.restorePasswordByEmail({ email: value });

      handleOption(0);
      toastr.success(
        'Verifique seu email',
        'Se o e-mail estiver cadastrado, enviaremos as instruções para redefinir a senha.',
      );
    } catch (err) {
      if (err?.response?.data?.message) {
        return toastr.error('Atenção', err.response.data.message);
      }
      return toastr.error('Erro ao tentar enviar o e-mail');
    } finally {
      setLoading(false);
    }
  };

  const handleValidateCode = async () => {
    setLoading(true);
    try {
      const data = await UserRepository.verifyPhoneCode({
        challenge,
        code: inputCode,
      });
      if (!data || !data.token) {
        return toastr.error('Token inválido', 'Verifique o código e tente novamente');
      }
      history.push({ search: `?token=${encodeURIComponent(data.token)}` });
      handleOption(2);
    } catch (err) {
      toastr.error(
        'Token inválido ou expirado',
        err?.response?.data?.message ||
          'Verifique o código e tente novamente, ou solicite um novo.',
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    value,
    setValue,
    loading,
    handleSubmit,
    phoneFlow,
    inputCode,
    setInputCode,
    handleValidateCode,
  };
};
